import { useFormContext } from 'shared-widget-components/src/providers/FormContextProvider';
import { Carousel } from '../../models/CarouselModel';
import { CarouselElement } from './CarouselElement';
import { previewScrollbar } from 'shared-widget-components/src/components/preview/previewScrollbar';
import { useWatch } from 'react-hook-form';
import useInitCarouselSlides from '../widgetSettings/hooks/useInitCarouselSlides';
import { useEffect, useState } from 'react';
import { BaseSlide } from '../../models/slides/BaseSlide';
import { CarouselLoadingSkeleton } from '../skeleton/CarouselLoadingSkeleton';

interface CarouselPreviewProps {
  item: Carousel;
}

/**
 * CarouselPreview component
 * this component is responsible for rendering the preview of the carousel
 * @param item - the item of the carousel
 * @returns CarouselPreview component
 */
const CarouselPreview = ({ item }: CarouselPreviewProps) => {
  const { control } = useFormContext();
  const slideDatas: BaseSlide[] = useWatch({ control, name: 'slideDatas' });
  const [slides, setSlides] = useState<BaseSlide[]>([]);

  const { isLoading } = useInitCarouselSlides({ slides: item.slides });

  useEffect(() => {
    if (!slideDatas) return;
    setSlides(slideDatas);
  }, [slideDatas]);

  if (isLoading) return <CarouselLoadingSkeleton />;

  return (
    <div className='flex justify-center  min-h-[200px] mx-auto w-full h-full previewScrollbar min-[350px]:overflow-y-auto min-[350px]:overflow-x-hidden sm:overflow-hidden '>
      <style>{previewScrollbar}</style>
      <div className='flex justify-center min-[350px]:py-4 md:py-6 lg:py-10 relative min-[350px]:items-start sm:items-center  mx-auto w-full ' style={{ background: item.backgroundColor }}>
        {slides?.length > 0 && (
          <div className='w-full max-w-[1240px] mx-auto'>
            <CarouselElement slides={slides} autoPlay={item.autoPlay} textColor={item.textColor} buttonColor={item.buttonColor} buttonTextColor={item.buttonTextColor} />
          </div>
        )}
      </div>
    </div>
  );
};

export default CarouselPreview;
